import { useEffect, useState } from 'react';
import { getToken, resolveOrgId } from '../utils/authHeaders';

// Identity comes from AuthProvider's /auth/me result, never a persisted bearer token.
export function useDeviceScope(userId, token) {
  const [, changed] = useState(0);
  useEffect(() => {
    const bump = () => changed((n) => n + 1);
    const events = ['locationChanged', 'organizationChanged', 'storage'];
    events.forEach((e) => window.addEventListener(e, bump));
    return () => events.forEach((e) => window.removeEventListener(e, bump));
  }, []);
  const authenticated = Boolean(token) && token === getToken();
  return { userId: authenticated ? userId : null, token: authenticated ? token : null,
    orgId: resolveOrgId(), locationId: localStorage.getItem('current_location_id') || '' };
}

export const completeScope = (s) => Boolean(s?.userId && s?.orgId && s?.locationId);
export const sameScope = (row, s) => completeScope(s) && Boolean(row?.user_id && row?.organization_id && row?.location_id)
  && row.user_id === s.userId && row.organization_id === s.orgId && row.location_id === s.locationId;
export const currentSession = (s) => completeScope(s) && Boolean(s.token) && s.token === getToken()
  && s.orgId === resolveOrgId() && s.locationId === (localStorage.getItem('current_location_id') || '');
export const scopeKey = (s) => JSON.stringify([s.userId, s.orgId, s.locationId]);
